import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ServerlessGPUPlaygroundRun from './run';
import ServerlessGPUPlaygroundRequirements from './requirements';
import ServerlessGPUPlaygroundDeploy from './deploy';
import { Link, useSearchParams } from 'react-router-dom';
import ViewCredit from '@/pages/setting/payment/view-credit';
import { Button } from '@/components/ui/button';
import { BookText, Code2 } from 'lucide-react';
import { PATH_EXAMPLE } from '@/constants';

const ServerlessGPUPlayground = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'run';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="container">
      <div className="flex justify-end my-2">
        <Link
          to={PATH_EXAMPLE}
          className="underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            variant={'outline'}
            startIcon={<Code2 className="h-4 w-4" />}
          >
            Examples
          </Button>
        </Link>
      </div>
      <Tabs value={tab} onValueChange={handleTabChange}>
        <TabsList variant={'outline'}>
          <TabsTrigger value="run" variant={'outline'}>
            Run
          </TabsTrigger>
          <TabsTrigger value="deploy" variant={'outline'}>
            Deploy
          </TabsTrigger>
          <TabsTrigger value="requirements" variant={'outline'}>
            Requirements
          </TabsTrigger>
        </TabsList>
        <TabsContent value="run">
          <ServerlessGPUPlaygroundRun />
        </TabsContent>
        <TabsContent value="deploy">
          <ServerlessGPUPlaygroundDeploy />
        </TabsContent>
        <TabsContent value="requirements">
          <ServerlessGPUPlaygroundRequirements />
        </TabsContent>
      </Tabs>
      <div className="mt-6 border-t pt-6">
        <ViewCredit isShowPaymentLink={true} />
      </div>
    </div>
  );
};

export default ServerlessGPUPlayground;
